export enum ConnectionSourceLastExecutions {
  Never = 'Never',
  InProgress = 'In Progress',
  Failed = 'Failed'
}
